export enum MAIN_PAGE {
    LOGOUT = "LOGIN",
    TRANSLATE = "TRANSLATE",
    CONFIRM_TRANSLATE = "CONFIRM_TRANSLATE",
    SELF_CONFIG = "SELF_CONFIG",
    USER_CONFIG = "USER_CONFIG"
}
